import { createModuleBuilder } from '@evidentid/dashboard-commons/app';
import { GatewayApiClient } from '@evidentid/gateway-api-client';

export const documentDataReviewModule = createModuleBuilder()
    .demandContext<{
    gatewayClient: GatewayApiClient;
}>()
    .injectVue((app) => ({
        $gatewayClient: app.gatewayClient,
    }))
    .end();
